import e from"../../node_modules/style-inject/dist/style-inject.es.js";var o={"carrier-logo-component":"_carrier-logo-component_4gfy7_1"};e("._carrier-logo-component_4gfy7_1{display:inline-flex;max-height:24px}");export{o as default};
//# sourceMappingURL=carrier-logo.module.less.js.map
